var generic = generic || {};
var site = site || {};

site.template = site.template || {};
site.pp = site.pp || {};
site.pp.loyalty = site.pp.loyalty || {};
site.pp.product_details = site.pp.product_details || {};
site.pp.hasFlashRewards = site.pp.hasFlashRewards || false;
site.pp.loyalty.translations = site.pp.loyalty.translations || {};
site.pp.loyalty.email = site.pp.loyalty.email || '';
site.pp.loyalty.taborder = site.pp.loyalty.taborder || [];
site.pp.loyalty.isRewardClicked = site.pp.loyalty.isRewardClicked || false;
site.pp.tabNameToShow = site.pp.tabNameToShow || '';
/**
 * attached
 * _response
 * _rewards
 * _getImagePath
 * _callback
 * _fetch
 * _setMemberPoints
 * responseHandler
 * get
 * redeem
 * getSitesForReward
 * getProduct
 * destroyCache
 * filter
 * tierToLink
 */

(function ($) {
  'use strict';

  Drupal.behaviors.purePrivilegeRewardsV2 = {
    attached: false,
    _response: undefined,
    _rewards: undefined,

    _getImagePath: function (reward) {
      return '/media/images/pure_privilege/rewards/' + reward.rewardCode + '.jpg';
    },

    _callback: function (callback) {
      return typeof callback === 'function' ? callback : $.noop;
    },

    _fetch: function (method, params, callback) {
      if (typeof callback !== 'function') {
        callback = $.noop;
      }

      return generic.jsonrpc.fetch({
        method: method,
        params: [params],
        onSuccess: function (jsonRpcResponse) {
          var data = jsonRpcResponse.getValue();

          callback(null, data);
        },
        onFailure: function (jsonRpcResponse) {
          var errors = jsonRpcResponse.getError();
          var response;

          try {
            if ($.isArray(errors.data.messages)) {
              response = errors.data.messages;
            } else {
              response = [{ text: errors.message }];
            }
            generic.overlay.launch({
              content: errors.data.messages[0].text
            });
          } catch (e) {
            generic.overlay.launch({
              content: 'Error data'
            });
          }
          callback(response);
        }
      });
    },

    _setMemberPoints: function (newPoints) {
      var self = this;

      try {
        if (!newPoints || $.trim(newPoints) === '') {
          newPoints = 0;
        }

        self._response.member_info.pointBalance = newPoints;
      } catch (e) {
        self._response.member_info.pointBalance = 0;
      }
    },

    responseHandler: function (options, callback) {
      var self = this;
      // Build the response, handle various options.
      var response = $.extend(true, {}, self._response);
      var rewards, memberRewards, member;
      var pointBalance = 0;

      try {
        member = response.member_info;
        if (typeof member.pointBalance === 'undefined') {
          member = null;
        }
        pointBalance = member.pointBalance;
        if (site.pp.loyalty.translations.enable_cart_redeem && site.pp.loyalty.member_info !== null  && member.pointBalanceModified > 0) {
          pointBalance = member.pointBalanceModified;
        }
      } catch (e) {
        member = null;
      }
      try {
        memberRewards = response.user_rewards.rewards.rewardCodes;
      } catch (e) {
        memberRewards = null;
      }

      // Add disabled property for items that the user cannot redeem.
      _.each(response.full_catalog.rewards, function (reward, i) {
        reward.disabled = true;
        reward.insufficientPoints = true;

        reward.rewardImage = self._getImagePath(reward);

        if (
          memberRewards &&
          typeof memberRewards[reward.rewardCode] !== 'undefined' &&
          memberRewards[reward.rewardCode] === 1 &&
          member &&
          member.pointBalance >= reward.rewardPoints
        ) {
          reward.disabled = false;
          reward.insufficientPoints = false;
        }

        // If the tierName is not starts with TIER then it has flash rewards configured.
        // The tierName of the flash rewards like FLASH-TIER so we are splitting the FLASH keyword to separte the tiers.
        // Understanding is tierName always contain -TIER as the second part and FLASH/LIMITED keyword as first.
        if (
          !reward.tierName.startsWith('TIER') &&
          typeof site.pp.loyalty.translations.flash_reward_name === 'undefined'
        ) {
          var flashName = reward.tierName.split('-');

          site.pp.loyalty.translations.flash_reward_name = flashName[0];
        }

        if (reward.tierName.startsWith('TIER')) {
          var tierNumber = self.tierToNumber(reward.tierName);
          if (site.pp.loyalty.taborder.indexOf(tierNumber) === -1) {
            site.pp.loyalty.taborder.push(tierNumber);
          }
        }

        if (
          site.pp.loyalty.translations.flash_reward_name &&
          reward.tierName.startsWith(site.pp.loyalty.translations.flash_reward_name) &&
          typeof reward.flashReward === 'undefined'
        ) {
          reward.isEligible = reward.rewardPoints <= pointBalance ? true : false;
          var flashReward = $.extend({}, response.full_catalog.rewards[i]);

          flashReward.flashReward = true;
          var tierLevel = flashReward.tierName.split('-');

          flashReward.tierLevel = tierLevel[1];
          flashReward.name = tierLevel[1];
          flashReward.tierNumber = self.tierToNumber(reward.tierName);
          response.full_catalog.rewards.push(flashReward);
          reward.tierName = tierLevel[1];
          reward.flashReward = true;
          if (!site.pp.hasFlashRewards) {
            site.pp.hasFlashRewards = true;
            site.pp.loyalty.hasFlashRewards = true;
          }
        }
        response.full_catalog.rewards[i] = reward;
      });

      if (site.pp.hasFlashRewards && site.pp.loyalty.translations.flash_reward_tab_name === '') {
        site.pp.loyalty.translations.flash_reward_tab_name = 'LIMITED TIME';
      }

      if (
        site.pp.hasFlashRewards &&
        typeof site.pp.loyalty.translations.flash_reward_id === 'undefined'
      ) {
        site.pp.loyalty.translations.flash_reward_id = 'flash-reward';
      }

      // Assign products to tiers.
      if (options.filter) {
        response.full_catalog.rewards = self.filter(response.full_catalog.rewards);
      }

      try {
        rewards = response.full_catalog.rewards;
      } catch (e) {
        generic.overlay.launch({
          content: 'Error data'
        });
      }

      callback(null, response, rewards, memberRewards, member);
    },

    get: function (options, callback) {
      var self = this;
      var defaults = {};
      var path = 'pure_privilege.getCombinedRewardsCatalog';

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      callback = self._callback(callback);

      defaults.params = {};
      defaults.params.full_catalog = 1;
      if (site.pp.loyalty.translations.enable_rewards_sort && site.rewardsSortBy) {
        defaults.params.sortBy = site.rewardsSortBy;
      }
      var signedIn =
        Number(site.userInfoCookie.getValue('signed_in')) === 1 ||
        Number(site.userInfoCookie.getValue('csr_logged_in')) === 1;
      var urlArray = document.referrer.split('?');
      var returnPath = urlArray[0];
      var fileName = returnPath.substring(returnPath.lastIndexOf('/') + 1);

      defaults.params.force = signedIn && fileName === 'signin.tmpl' ? 1 : 0;
      // 1 = Active, 2 = Inactive, 3 = All
      defaults.params.rewards_active_type = 3;
      defaults.filter = true;

      options = $.extend(true, {}, defaults, options);
      options = $.extend(true, {}, defaults, options);

      // Check if we have a cached state.
      if (self._response) {
        return self.responseHandler(options, callback);
      }

      self._fetch(path, options.params, function (err, response) {
        if (err) {
          return callback(err);
        }

        // Cache rewards in an unfilitered state.
        self._response = response;
        self._rewards = response.full_catalog.rewards;

        self.responseHandler(options, callback);
      });
    },

    redeem: function (options, callback) {
      var self = this;
      var defaults = {};
      var path = 'pure_privilege.redeemReward';

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      callback = self._callback(callback);

      defaults.params = {};
      defaults.params.reward_code = 0;
      defaults.filter = true;

      options = $.extend(true, {}, defaults, options);

      self._fetch(path, options.params, function (err, response) {
        if (err) {
          return callback(err);
        }

        if ($.isPlainObject(response)) {
          // Update member points.
          // Yes, Available is misspelled coming from TecMark...
          self._setMemberPoints(response.totalAvaliablePoints);
        }

        callback(null, response);
      });
    },

    getSitesForReward: function (options, callback) {
      var self = this;
      // Get Salon sites for reward that has flag isRedeemableAtSite
      var defaults = {};
      var path = 'pure_privilege.getSitesForReward';

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      callback = self._callback(callback);

      defaults.params = {};
      defaults.params.reward_code = $.isPlainObject(options) ? 0 : options;

      options = $.extend(true, {}, defaults, options);

      self._fetch(path, options.params, function (err, response) {
        if (err) {
          return callback(err);
        }

        var INDEXED = {
          countries: {},
          states: {},
          cities: {},
          sites: {}
        };

        if (_.isArray(response.awardSites)) {
          _.each(response.awardSites, function (site) {
            if (typeof INDEXED.countries[site.country] === 'undefined') {
              INDEXED.countries[site.country] = [];
              INDEXED.countries[site.country].push(site.state);
            } else {
              if (INDEXED.countries[site.country].indexOf(site.state) === -1) {
                INDEXED.countries[site.country].push(site.state);
              }
            }

            if (typeof INDEXED.states[site.state] === 'undefined') {
              INDEXED.states[site.state] = [];
              INDEXED.states[site.state].push(site.city);
            } else {
              if (INDEXED.states[site.state].indexOf(site.city) === -1) {
                INDEXED.states[site.state].push(site.city);
              }
            }

            if (typeof INDEXED.cities[site.city] === 'undefined') {
              INDEXED.cities[site.city] = [];
              INDEXED.cities[site.city].push(site.siteNumber);
            } else {
              if (INDEXED.cities[site.city].indexOf(site.siteNumber) === -1) {
                INDEXED.cities[site.city].push(site.siteNumber);
              }
            }

            if (typeof INDEXED.sites[site.siteNumber] === 'undefined') {
              INDEXED.sites[site.siteNumber] = site;
            }
          });
        }

        callback(null, response, INDEXED);
      });
    },

    getProduct: function (rewardCode, callback) {
      var self = this;
      var found = false;

      callback = self._callback(callback);

      self.get(function (err, response) {
        // Iterate through the cached, unmodified version.
        $.each(self._rewards, function (index, reward) {
          var member;

          if (reward.rewardCode === rewardCode) {
            try {
              member = response.member_info;
            } catch (e) {
              generic.overlay.launch({
                content: 'Error data'
              });
            }
            reward.tierLink = self.tierToLink(reward.tierName);
            callback(null, reward, member);
            found = true;

            return false;
          }
        });

        if (found === false) {
          callback('Reward not found.');
        }
      });
    },

    destroyCache: function () {
      var self = this;

      self._response = undefined;
      self._rewards = undefined;
    },

    filter: function (_rewards) {
      var self = this;
      var rewards = {};
      var _r = [];
      var $currentIndex = '';
      var indexBreak = 2;

      if (site.pp.isMobile) {
        indexBreak = 1;
      }

      // Creating the Tab to render in correct order - Limited tiers followed by others
      if (
        typeof rewards[site.pp.loyalty.translations.flash_reward_tab_name] === 'undefined' &&
        site.pp.hasFlashRewards
      ) {
        rewards[site.pp.loyalty.translations.flash_reward_tab_name] = {
          flashTab: true,
          productIndex: 0,
          products: []
        };
      }

      if (typeof site.pp.loyalty.taborder !== 'undefined' && site.pp.loyalty.taborder.length > 0) {
        site.pp.loyalty.taborder.sort();
        for (var i = 0; i < site.pp.loyalty.taborder.length; i++) {
          rewards['TIER' + site.pp.loyalty.taborder[i]] = {
            isEligible: false,
            productIndex: 0,
            products: []
          };
        }
      }

      // Assign rewards to their respective tiers.
      $.each(_rewards, function (index, reward) {
        // Adding the flash-tier object to show it as first tab in rewards page.
        if (
          typeof rewards[reward.tierName] !== 'undefined' &&
          reward.tierName.startsWith('TIER') &&
          rewards[reward.tierName].products.length === 0
        ) {
          rewards[reward.tierName].className = self.tierToLink(reward.tierName);
          rewards[reward.tierName].name = reward.tierName;
          rewards[reward.tierName].tierNumber = self.tierToNumber(reward.tierName);
          rewards[reward.tierName].points = reward.rewardPoints;
        }
        $currentIndex = rewards[reward.tierName];
        if (
          typeof rewards[site.pp.loyalty.translations.flash_reward_tab_name] !== 'undefined' &&
          reward.tierName.startsWith(site.pp.loyalty.translations.flash_reward_name)
        ) {
          $currentIndex = rewards[site.pp.loyalty.translations.flash_reward_tab_name];
        }
        if ($currentIndex.productIndex === indexBreak) {
          reward.isRowEnd = true;
          $currentIndex.productIndex = 0;
        } else if ($currentIndex.productIndex === 0) {
          reward.isRowStart = true;
          $currentIndex.productIndex = $currentIndex.productIndex + 1;
        } else {
          $currentIndex.productIndex = $currentIndex.productIndex + 1;
        }
        if (reward.tierName.startsWith(site.pp.loyalty.translations.flash_reward_name)) {
          rewards[site.pp.loyalty.translations.flash_reward_tab_name].products.push(reward);
        } else {
          rewards[reward.tierName].products.push(reward);
        }
      });

      // Convert the object back into an array.
      $.each(rewards, function (index, reward) {
        // If member, then filter our the products that should not be displayed.
        var prodLength = reward.products.length - 1;

        reward.products[prodLength].isRowEnd = true;
        _r.push(reward);
      });

      return _r;
    },

    tierToLink: function (tierName) {
      return $.trim(tierName)
        .toLowerCase()
        .replace(/[^a-z\d]+/g, '-');
    },

    tierToNumber: function (tierName) {
      return tierName[tierName.length - 1];
    },

    tierUrlValidate: function () {
      var tierToShow = window.location.hash.substring(1) || '';

      tierToShow = tierToShow.replace(/[^\p{L}\d]/gu, '');
      if ($('.js-tabs-nav').find("[data-tab='" + tierToShow + "']").length > 0) {
        site.pp.tabNameToShow = tierToShow;

        return true;
      }

      return false;
    },

    renderTemplate: function ($template) {
      var self = this;

      self.get(function (options, response, rewards, memberRewards, member) {
        // console.log(options, response, rewards, memberRewards, member);
        self._response = response;
        self._rewards = rewards;
        /* eslint-disable vars-on-top */
        var $container = $template.find('.pure-privilege__rewards-tiers');
        var translations = $template.data('translations');
        var productContent = '';
        var hasDormantFeature = ($('.domain-us, .domain-ca, .domain-uk').length);
        var isDormantBannerHidden = localStorage.getItem('loyalty-dormant-banner-hidden');
        var isNotificationBannerHidden = localStorage.getItem('loyalty-notification-banner-hidden');
        /* eslint-disable vars-on-top */

        if (isDormantBannerHidden) {
          $('.pure-privilege-loyalty-dormant-banner').hide();
          $('.pure-privilege-dashboard__item--points-details').hide();
        }

        if (isNotificationBannerHidden) {
          $('.pure-privilege-loyalty-notification-banner').hide();
        }

        $('.pure-privilege-loyalty-status-banner__close-btn').on('click', function (clickEvent) {
          var parentContainer = $(this).closest('.pure-privilege-loyalty-status-banner');

          clickEvent.preventDefault();

          parentContainer.fadeOut(2500, function () {
            if (parentContainer.hasClass('pure-privilege-loyalty-dormant-banner')) {
              localStorage.setItem('loyalty-dormant-banner-hidden', 1);
            } else {
              localStorage.setItem('loyalty-notification-banner-hidden', 1);
            }
          });
        });

        _.extend(translations, {
          address: $template.find('.pure-privilege__rewards-address').html(),
          shipping: $template.find('.pure-privilege__rewards-shipping').html(),
          update_email_msg: $template.find('.pure-privilege__rewards-edit-email').html(),
          email_optin: $template.find('.pure-privilege__rewards-opt-email').html(),
          address_missing: $template.find('.pure-privilege__rewards-incomplete-address').html(),
          address_msg: $template.find('.pure-privilege__rewards-edit-address').html()
        });
        site.pp.loyalty.translations = translations;
        site.pp.loyalty.eligibleRewards = [];
        site.pp.loyalty.rewards = [];
        site.pp.loyalty.member = member;
        site.pp.loyalty.member_info = self._response.member_info;

        if (site.pp.loyalty.member_info && hasDormantFeature) {
          /* eslint-disable no-underscore-dangle */
          site.pp.loyalty.show_close_button =
          self._response.member_info.dormantStatus.POINTS_DID_EXPIRE;
          site.pp.loyalty.is_dormant = self._response.member_info.ppAccDormant || 0;
          /* eslint-enable no-underscore-dangle */
        }
        self._response = response;

        if (response.user_rewards === null) {
          site.pp.loyalty.rewards = rewards;
          site.pp.loyalty.isEligible = false;
          productContent = site.template.get({
            name: 'product_boutique',
            data: site.pp.loyalty
          });
          $container.append(productContent);
        } else {
          var rewardProducts = [];
          var pointBalance = self._response.member_info
            ? self._response.member_info.pointBalance
            : 0;
          var hasEligibleRewards = false;

          if (site.pp.loyalty.translations.enable_cart_redeem && site.pp.loyalty.member_info !== null  && self._response.member_info.pointBalanceModified > 0) {
            pointBalance = self._response.member_info.pointBalanceModified;
          }
          rewards.forEach(function (el) {
            if (el.points <= pointBalance) {
              el.isEligible = true;
              rewardProducts.push(el);
              hasEligibleRewards = true;
            } else {
              rewardProducts.push(el);
            }
          });
          if (hasEligibleRewards) {
            site.pp.loyalty.isEligible = true;
          }
          site.pp.loyalty.rewards = rewardProducts;
          productContent = site.template.get({
            name: 'product_boutique',
            data: site.pp.loyalty
          });
          $container.append(productContent);
        }

        // tab functionality for tier products
        if (window.location.hash && self.tierUrlValidate()) {
          var tierToShow = site.pp.tabNameToShow;

          $('.js-tabs-nav')
            .find("[data-tab='" + tierToShow + "']")
            .addClass('tab-active')
            .attr({
              'aria-selected': 'true',
              tabindex: '0'
            });
          $('.js-tier_product')
            .find('#' + tierToShow + '')
            .removeClass('hidden')
            .addClass('content-active');
        } else {
          var $firstTab = site.pp.hasFlashRewards
            ? $('.js-tier_product').find('.js-tabs-content').eq(1)
            : $('.js-tier_product').find('.js-tabs-content').eq(0);
          var $firstTier = site.pp.hasFlashRewards
            ? $template.find('.js-tiers-tab:eq(1)')
            : $template.find('.js-tiers-tab:eq(0)');

          if (site.pp.isMobile) {
            $firstTab.addClass('content-active');
          } else {
            $firstTier.addClass('tab-active').attr({
              'aria-selected': 'true',
              tabindex: '0'
            });
            $firstTab.removeClass('hidden').addClass('content-active');
          }
        }
        var $tabLists = $('.js-tabs-nav li', $template);

        $('.js-view-flash-rewards', $template).on('click', function (e) {
          e.preventDefault();
          $tabLists.first().trigger('click');
        });
        $tabLists.on('click keydown', function (e) {
          var tab_id = $(this).attr('data-tab');
          var parents = $(this).parents('.js-tier_product');
          var $active_content = $('.content-active', parents);
          var $active_tab = $('.tab-active', parents);
          var $next_active = $(this);
          var arrow_nav = false;

          if (e.keyCode === 39) {
            $next_active = $active_tab.next().length ? $active_tab.next() : $active_tab;
            tab_id = $next_active.attr('data-tab');
            arrow_nav = true;
          } else if (e.keyCode === 37) {
            $next_active = $active_tab.prev().length ? $active_tab.prev() : $active_tab;
            tab_id = $next_active.attr('data-tab');
            arrow_nav = true;
          }
          if (e.type === 'click' || arrow_nav) {
            if (site.pp.isMobile) {
              $active_content.removeClass('content-active');
              $('.' + tab_id).addClass('content-active');
            } else {
              $active_content.hide().removeClass('content-active');
              $('.' + tab_id)
                .show()
                .removeClass('hidden')
                .addClass('content-active');
              $active_tab.removeClass('tab-active custom-outline').attr({
                'aria-selected': 'false',
                tabindex: '-1'
              });
              $next_active
                .addClass('tab-active custom-outline')
                .attr({
                  'aria-selected': 'true',
                  tabindex: '0'
                })
                .focus();
            }
            if ($('.js-product_description-toggle').hasClass('active')) {
              $('.js-tier-description-close').trigger('click');
            }
          } else if (!e.shiftKey && e.keyCode === 9) {
            e.preventDefault();
            var $redeemProduct = $active_content.find('.js-tier-product').first();
            var $first_tabbable = $redeemProduct.addClass('focused').find(':tabbable').first();

            $first_tabbable.focus().addClass('custom-outline');
          } else if (e.shiftKey && e.keyCode === 9) {
            $active_tab.removeClass('custom-outline');
          }
          history.replaceState({}, '', '#' + tab_id);
        });

        var $first_activeDesc = $('.js-product_description-toggle', '.content-active').first();

        $first_activeDesc.on('keydown', function (e) {
          if (e.shiftKey && e.keyCode === 9) {
            e.preventDefault();
            $('.tab-active').focus().addClass('custom-outline');
            $('this').parents('.focused').removeClass('focused');
          }
        });

        $('.js-tier-product')
          .on('keydown', function (e) {
            var $redeemProduct = $(this);
            var lastTabbable = $(this).find(':tabbable').filter(':last');
            var firstTabbable = $(this).find(':tabbable').filter(':first');

            if (e.keyCode !== 9 || e.isDefaultPrevented()) {
              return;
            }
            if (e.target === lastTabbable[0] && !e.shiftKey) {
              $redeemProduct.removeClass('focused');
              if ($redeemProduct.hasClass('tier__products-product--last')) {
                $redeemProduct.nextAll('.js-tier-product').first().addClass('focused');
              } else {
                $redeemProduct.next().addClass('focused');
              }
            } else if (e.target === firstTabbable[0] && e.shiftKey) {
              $redeemProduct.removeClass('focused');
              if ($redeemProduct.hasClass('tier__products-product--first')) {
                $redeemProduct.prevAll('.js-tier-product').first().addClass('focused');
              } else {
                $redeemProduct.prev().addClass('focused');
              }
            }
          })
          .on('focusin', function () {
            $(this).addClass('focused');
          });

        $('.js-product_description-toggle').click(function (e) {
          e.preventDefault();
          var $product_grid = $('.js-product-carousel');
          var $product = $(this).parents('.tier__products-product');
          var $parents = $(this).parents('.js-tabs-content');
          var $tierProduct = $(this).parents('.js-tier-product');
          var $descriptionSection = $tierProduct.nextAll('.js-tier-product_description:first');
          var $active_elem = $product_grid.find('.description_active');
          var $productSlick = $('.js-product-slick');
          var reward_tier = [];

          if ($(this).hasClass('active')) {
            $('.js-tier-description-close').trigger('click');
          } else {
            var tier_name = $product.data('tier-name');
            var productCode = $(this).data('reward-code');

            if ($parents.hasClass('js-eligible-tabs-content')) {
              reward_tier = site.pp.loyalty.rewards;
              site.pp.product_details.isEligible = 1;
            } else {
              reward_tier = site.pp.loyalty.rewards;
              site.pp.product_details.isEligible = 0;
            }

            var selected_tier = reward_tier.filter(function (el) {
              return el.name === tier_name;
            });
            var selected_product = selected_tier[0].products.filter(function (el) {
              return el.rewardCode === productCode;
            });

            site.pp.product_details.products = selected_product;
            site.pp.product_details.translations = translations;
            site.pp.product_details.member_info = self._response.member_info;
            var template = 'product_boutique_desc';
            var html = site.template.get({
              name: template,
              data: site.pp.product_details
            });

            if ($active_elem.length) {
              $('.js-tier-description-close').trigger('click');
            }
            $(this).addClass('active');
            $descriptionSection.append(html).slideDown().focus();
            $product.addClass('description_active');
            $(this).attr('aria-expanded', 'true');
            site.restrict_navigation($('.js-product__description'));
            if (site.pp.isMobile) {
              $productSlick.find('.slick-list').height('auto');
              $productSlick.get(0).slick.setPosition();
            }
          }
          $descriptionSection.find('.js-product-redeem').click(function (e) {
            e.preventDefault();
            $('.description_active').find('.js-product-redeem').trigger('click');
          });
        });

        $(document).on('click keydown', '.js-tier-description-close', function (e) {
          var $active_product = $('.description_active');

          if (e.keyCode === 13 || e.type === 'click') {
            e.preventDefault();
            var $active_link = $active_product.find('.js-product_description-toggle');

            $('.js-product__description').remove();
            $active_link.attr('aria-expanded', 'false').focus().removeClass('active');
            $active_product.removeClass('description_active');
            if (site.pp.isMobile) {
              $('.js-product-slick').get(0).slick.setPosition();
            }
          }
          if (e.type === 'click') {
            $active_product.removeClass('focused');
          }
        });

        var $date = new Date(Date.now());

        $date = $date.toLocaleString();
        $('.js-ordered-date').append($date);

        // Redeem section
        $('.js-product-redeem').click(function () {
          var $that = $(this);
          var isRedeemableAtSite = $(this).data('redeemable-site');
          var isValidateEmail = $(this).data('validate-email');
          var parents = $(this).parents('.js-tier-product');
          var $redeem = $('.js-product-redeem_section', parents);
          var redeemedProduct = false;

          $redeem.find('.js-product-redeem-cancel').click(function () {
            $.colorbox.close();

            return false;
          });

          // Validate the PP Email
          var $email = '';

          if (isValidateEmail) {
            $email = site.pp.loyalty.email
              ? site.pp.loyalty.email
              : self._response.member_info.email;
            $('.js-email-update', $template)
              .off()
              .on('click', function () {
                var emailUpdateTmpl =
                  '/account/pure_privilege/includes/pure_privilege_email_update.tmpl';

                generic.template.get({
                  path: emailUpdateTmpl,
                  callback: function (html) {
                    generic.overlay.launch({
                      content: html,
                      overlayclose: false,
                      closebutton: false,
                      cssStyle: {
                        width: 680,
                        height: 440
                      },
                      onComplete: function () {
                        var $updateOverlay = $('.js-pp-email-overlay');

                        $('.js-pp-email-update', $updateOverlay)
                          .off()
                          .on('click', function (e) {
                            e.preventDefault();
                            $updateOverlay.find('li').addClass('hidden');
                            var email = $('.js-pp-email', $updateOverlay).val();
                            var confirmEmail = $('.js-pp-email-verify', $updateOverlay).val();
                            var emailPattern = /[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;

                            if (!emailPattern.test(email)) {
                              $updateOverlay.find('.js-email-invalid').removeClass('hidden');

                              return false;
                            }
                            if (email === confirmEmail) {
                              var options = {
                                _SUBMIT: 'pure_priv_account_update',
                                member_id: self._response.member_info.ppNumber,
                                Email: email
                              };

                              generic.jsonrpc.fetch({
                                method: 'pure_privilege.updateEmail',
                                params: [options],
                                onBoth: function (response) {
                                  site.pp.loyalty.email = email;
                                  $that.trigger('click');
                                }
                              });
                            } else {
                              $updateOverlay.find('.js-email-mismatch').removeClass('hidden');
                            }
                          });
                      },
                      onClosed: function () {
                        $that.trigger('click');
                      }
                    });
                  }
                });

                return false;
              });
          }

          // setup mailing address
          var $address = '';

          if (self._response.member_info) {
            var $firstName = self._response.member_info.firstName
              ? self._response.member_info.firstName
              : '';
            var $lastName = self._response.member_info.lastName
              ? self._response.member_info.lastName
              : '';
            var $fullName =
              $firstName && $lastName
                ? $firstName + ' ' + $lastName + '<br />'
                : $firstName + $lastName + '<br />';
            var $addressLine1 = self._response.member_info.addressLine1
              ? self._response.member_info.addressLine1 + '<br />'
              : '';
            var $addressLine2 = self._response.member_info.addressLine2
              ? self._response.member_info.addressLine2 + '<br />'
              : '';
            var $city = self._response.member_info.city ? self._response.member_info.city : '';
            var $state = self._response.member_info.state ? self._response.member_info.state : '';
            var $postalCode = self._response.member_info.postalCode
              ? self._response.member_info.postalCode
              : '';
            var $addressLine3 =
              $city && $state
                ? $city + ', ' + $state + ' ' + $postalCode
                : $city + $state + ' ' + $postalCode;

            $address = $fullName + $addressLine1 + $addressLine2 + $addressLine3 + '<br/>' + $email;
          }

          $redeem.find('.js-address').html($address);

          var $emailOpt = $redeem.find('.js-email-share');
          var isEmailOpt = false;

          $emailOpt.on('click', function () {
            if ($(this).is(':checked')) {
              isEmailOpt = true;
            } else {
              isEmailOpt = false;
            }
          });

          var $emailConfirm = $redeem.find('.js-confirm-email');
          var isEmailConfirm = false;

          $emailConfirm.on('click', function () {
            if ($(this).is(':checked')) {
              isEmailConfirm = true;
            } else {
              isEmailConfirm = false;
            }
          });

          if (site.pp.loyalty.email) {
            $emailConfirm.trigger('click');
          }
          var $redeemConfirmButton = $redeem.find('.js-product-redeem-confirm');

          $redeemConfirmButton.off().on('click', function () {
            var $that = $(this);

            $that.addClass('hidden').next('.loading').removeClass('hidden');
            var rewardCode = $(this).data('reward-code');
            var $confirmWindow = $(this).parents('.js-product-redeem_section');
            var $siteOption = $('.js-site', $confirmWindow);
            var siteNumber = $(this).data('site-number') || $siteOption.val() || '';
            var isRedeemableAtSite = $(this).data('redeemable-site');
            var isValidateEmail = $(this).data('validate-email');
            var options = {
              reward_code: rewardCode
            };

            if (!!isRedeemableAtSite && !!siteNumber) {
              options.siteNumber = siteNumber;
            }

            if (isRedeemableAtSite) {
              var country = $('.js-country', $confirmWindow).val() || '';
              var state = $('.js-state', $confirmWindow).val() || '';
              var city = $('.js-city', $confirmWindow).val() || '';
              var siteId = $siteOption.val() || '';

              if (country === '' || state === '' || city === '' || siteId === '') {
                $('.js-site-error', $confirmWindow).removeClass('hidden');
                $siteOption.addClass('error');
                $that.removeClass('hidden').next('.loading').addClass('hidden');

                return false;
              }
            }

            if (isValidateEmail) {
              if (isEmailOpt) {
                options.EmailOptIn = 1;
              }
              if (!isEmailConfirm) {
                $that.removeClass('hidden').next('.loading').addClass('hidden');
                $('.js-confirm-email', $confirmWindow).parent().addClass('error');

                return false;
              }
            }

            var site_country = $.cookie('LOCALE').slice(-2);

            if (site.pp.loyalty.member_info.country.trim() !== site_country) {
              var $content = site.pp.loyalty.translations.address_msg;

              generic.overlay.launch({
                content: $content
              });
            } else {
              self.redeem(
                {
                  params: options
                },
                function (err, response) {
                  if (response.transactionId) {
                    $that.removeClass('hidden').next('.loading').addClass('hidden');
                    $(document).trigger('pure_privilege.loaded', [response]);
                    $template
                      .find('.js-product-redeem-header .points')
                      .text(response.pointBalanceFormatted);
                    $confirmWindow
                      .find('.js-product-redeem-header .points')
                      .text(response.pointBalanceFormatted);
                    $confirmWindow
                      .find('.step1')
                      .addClass('hidden');
                    $confirmWindow
                      .find('.step2')
                      .removeClass('hidden');
                    $.colorbox.resize();
                    redeemedProduct = true;
                  }
                }
              );
            }

            return false;
          });

          var signedIn =
            Number(site.userInfoCookie.getValue('signed_in')) === 1 ||
            Number(site.userInfoCookie.getValue('csr_logged_in')) === 1;

          if (signedIn && !self._response.member_info.ppNumber && $container.data('redirection')) {
            window.location.pathname = '/account/pure_privilege/transactions.tmpl';
            return true;
          } else {
            var $details = $redeem.clone(true).removeClass('hidden');

            if ($(this).data('redeemable-site')) {
              var rewardCode = $(this).data('reward-code');
              var $tierselects = $('.js-product-redeem-selects', $details);

              self.getSitesForReward(
                { params: { reward_code: rewardCode } },
                function (options, response, INDEXED) {
                  var $countries = $('.js-country', $tierselects);
                  var $states = $('.js-state', $tierselects);
                  var $cities = $('.js-city', $tierselects);
                  var $sites = $('.js-site', $tierselects);

                  _.each(Object.getOwnPropertyNames(INDEXED.countries), function (country) {
                    $('<option value="' + country + '">' + country + '</option>').appendTo(
                      $countries
                    );
                  });

                  $countries.change(function () {
                    $states.empty();
                    $(
                      '<option value="" selected disabled>' + translations.state + '</option>'
                    ).appendTo($states);

                    $cities.empty();
                    $(
                      '<option value="" selected disabled>' + translations.city + '</option>'
                    ).appendTo($cities);

                    $sites.empty();
                    $(
                      '<option value="" selected disabled>' + translations.site + '</option>'
                    ).appendTo($sites);

                    var stateAlp = INDEXED.countries[$(this).val()];

                    _.each(stateAlp.sort(), function (state) {
                      $('<option value="' + state + '">' + state + '</option>').appendTo($states);
                    });
                  });

                  $states.change(function () {
                    $cities.empty();
                    $(
                      '<option value="" selected disabled>' + translations.city + '</option>'
                    ).appendTo($cities);

                    $sites.empty();
                    $(
                      '<option value="" selected disabled>' + translations.site + '</option>'
                    ).appendTo($sites);

                    var cityAlp = INDEXED.states[$(this).val()];

                    _.each(cityAlp.sort(), function (city) {
                      $('<option value="' + city + '">' + city + '</option>').appendTo($cities);
                    });
                  });

                  $cities.change(function () {
                    $sites.empty();
                    $(
                      '<option value="" selected disabled>' + translations.site + '</option>'
                    ).appendTo($sites);

                    _.each(INDEXED.cities[$(this).val()], function (site) {
                      $(
                        '<option value="' +
                          INDEXED.sites[site].siteNumber +
                          '">' +
                          INDEXED.sites[site].siteName +
                          ', ' +
                          INDEXED.sites[site].siteAddress +
                          '</option>'
                      ).appendTo($sites);
                    });
                  });

                  $sites.change(function () {
                    var siteNumber = $(this).val();

                    $details
                      .find('.js-product-redeem-confirm')
                      .attr('data-site-number', siteNumber);
                  });

                  generic.overlay.launch({
                    content: $details,
                    onClosed: function () {
                      if (redeemedProduct) {
                        location.reload();
                      }
                    }
                  });
                }
              );
            } else {
              generic.overlay.launch({
                content: $details,
                onClosed: function () {
                  if (redeemedProduct) {
                    location.reload();
                  }
                }
              });
            }

            return false;
          }
        });
        if (site.pp.isMobile) {
          $('.js-tabs-content').removeClass('hidden');
          $('.js-product-slick').slick({
            lazyLoad: 'progressive',
            adaptiveHeight: true,
            arrows: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: '.js-nav-slick'
          });
          $('.js-nav-slick').slick({
            arrows: false,
            centerMode: true,
            infinite: true,
            asNavFor: '.js-product-slick',
            slidesToShow: 3,
            slidesToScroll: 1,
            adaptiveHeight: true,
            focusOnSelect: true
          });

          if (window.location.hash && site.pp.tabNameToShow !== '') {
            var regNum = /[0-9]/g;
            var tierIndex = site.pp.tabNameToShow.match(regNum);
            if (!site.pp.hasFlashRewards) {
              tierIndex = tierIndex - 1;
            }
            $('.js-tiers-tab').removeClass('tab-active');
            $('.js-product-slick').slick('slickGoTo', tierIndex);
          } else {
            $('.js-product-slick').slick('slickGoTo', 0);
          }
        }
        $template.find('.pure-privilege__rewards-loading').addClass('hidden');
        $(document).on('click', '.js-reward-cart', function() {
          site.pp.loyalty.isRewardClicked = true;
        })
        $(document).on('addToCart.success addToCart.failure', function(e, results) {
          if (!_.isUndefined(results) && !_.isUndefined(results.ac_results) && !_.isUndefined(results.ac_results[0])
            && !_.isUndefined(results.ac_results[0].result)) {
            if (!_.isUndefined(results.ac_results[0].result.CARTITEM)
              && !_.isUndefined(results.ac_results[0].result.CARTITEM['category.CATEGORY_NAME'])) {
              if (results.ac_results[0].result.CARTITEM['category.CATEGORY_NAME'] === 'rewards') {
                location.reload();
              } else if (site.pp.loyalty.isRewardClicked) {
                location.reload();
              }
            }
          } else if (site.pp.loyalty.isRewardClicked) {
            location.reload();
          }
        });
      });
    },

    init: function ($template) {
      var self = this;
      var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
      var bPlargeUp = parseInt(Unison.fetch.all()['small'], 10);

      site.pp.isMobile = currentBpWidth <= bPlargeUp;

      site.pp.loyalty.translations = $template.data('translations');
      // IE polyfill for startsWith.
      if (!String.prototype.startsWith) {
        String.prototype.startsWith = function (searchString, position) {
          position = position || 0;

          return this.indexOf(searchString, position) === position;
        };
      }
      self.renderTemplate($template);
    },
    attach: function (context) {
      var self = this;
      var $template = $('.js-pure-privilege-rewards--v2', context);

      if (!self.attached && $template.length) {
        self.init($template);
        self.attached = true;
      }
    }
  };
})(jQuery);
